import { useLanguage } from "../LanguageContext";
import AboutImage from "../assets/about.avif";

export default function AboutView({ navigate }) {
  const { isAr } = useLanguage();
  const t = (en, ar) => (isAr ? ar : en);

  const advantages = [
    { icon: "ph-bold ph-shield-check",          label: t("Strict Safety Standards",   "معايير سلامة صارمة") },
    { icon: "ph-bold ph-truck",                  label: t("Comprehensive Logistics",   "لوجستيات شاملة") },
    { icon: "ph-bold ph-certificate",            label: t("Certified Engineering",     "هندسة معتمدة") },
    { icon: "ph-bold ph-globe-hemisphere-west",  label: t("Global Standards",          "معايير عالمية") },
  ];

  return (
    <div className="view-enter pt-24 sm:pt-28 md:pt-32 pb-12 sm:pb-16 md:pb-20 px-4 sm:px-6 bg-secondary-50 min-h-screen">
      <div className="max-w-7xl mx-auto w-full">
        {/* Page Header */}
        <div className="text-center mb-16">
          <h3 className="text-axion-base font-bold tracking-widest uppercase mb-2 text-sm font-display">
            {t("Our Story", "قصتنا")}
          </h3>
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-gray-900 mb-4 font-display">
            {t("About Axion Railway", "عن أكسيون للسكك الحديدية")}
          </h1>
          <h2 className="text-base sm:text-lg md:text-xl text-neutral-600 font-light max-w-xl md:max-w-2xl mx-auto font-display">
            {t("Engineering Excellence", "التميز الهندسي")}
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-12 lg:gap-16 items-center">
          {/* Image */}
          <div className="order-1 relative">
            <div className="rounded-3xl overflow-hidden shadow-large h-[300px] sm:h-[400px] md:h-[500px] lg:h-[600px] relative">
              <img
                src={AboutImage}
                alt={t("Engineers working on railway", "مهندسون يعملون على السكك الحديدية")}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-primary-600/30 to-primary-800/30 mix-blend-multiply" />
            </div>
            {/* Floating Badge */}
            <div className="absolute -bottom-4 -right-2 sm:-bottom-6 sm:-right-4 md:-bottom-8 md:-right-8 bg-white p-3 sm:p-6 md:p-8 rounded-xl sm:rounded-2xl shadow-medium border border-neutral-200/50 backdrop-blur-sm">
              <div className="text-2xl sm:text-4xl font-black text-primary-700 font-display">50+</div>
              <div className="text-neutral-600 font-bold uppercase tracking-wider text-xs sm:text-sm mt-1">
                {isAr ? <>مشروع<br />ناجح</> : <>Successful<br />Projects</>}
              </div>
            </div>
          </div>

          {/* Text */}
          <div className="order-2 mt-6 sm:mt-0">
            <h2 className="text-sm font-bold tracking-wider text-primary-700 uppercase mb-6 font-display">
              {t("Our Advantages", "مزاياهم")}
            </h2>

            <div className="text-base sm:text-lg text-neutral-600 font-light space-y-4 sm:space-y-6 mb-8 sm:mb-10">
              <p className="text-xl sm:text-2xl font-medium text-neutral-800 leading-snug">
                {t(
                  "Axion railway has developed into a trusted partner for rail infrastructure projects in Saudi Arabia and Europe.",
                  "طورت أكسيون للسكك الحديدية نفسها لتصبح شريكاً موثوقاً به لمشاريع البنية التحتية للسكك الحديدية في المملكة العربية السعودية وأوروبا."
                )}
              </p>
              <p>
                {t(
                  "We combine extensive local expertise with renowned German precision engineering. Our highly specialized teams execute complex projects safely, accurately, and strictly in accordance with DB (Deutsche Bahn) standards and project specifications.",
                  "نجمع بين الخبرة المحلية الواسعة والدقة الهندسية الألمانية المشهورة. تنفذ فرقنا المتخصصة للغاية المشاريع المعقدة بأمان ودقة ووفقاً صارماً لمعايير DB (دويتشه بان) ومواصفات المشاريع."
                )}
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-8 sm:mb-10">
              {advantages.map(({ icon, label }) => (
                <div key={label} className="flex items-center gap-4 bg-gray-50 p-4 rounded-lg">
                  <div className="bg-white p-2 rounded-full shadow-sm text-axion-base">
                    <i className={`${icon} text-xl`} />
                  </div>
                  <span className="font-bold text-gray-800">{label}</span>
                </div>
              ))}
            </div>

            <button
              onClick={() => navigate("projects")}
              className="bg-axion-base text-white px-6 sm:px-8 py-3 sm:py-4 rounded-md shadow-lg hover:bg-axion-light transition-all transform hover:-translate-y-1 font-bold tracking-wide flex items-center gap-2 sm:gap-3 w-full sm:w-auto justify-center"
            >
              {t("View Our Track Record", "اطلع على سجلنا")}
              <i className={`ph-bold ${isAr ? "ph-arrow-left" : "ph-arrow-right"}`} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
